import { render, staticRenderFns } from "./CourseCouponList.vue?vue&type=template&id=dd3e6888&scoped=true"
import script from "./CourseCouponList.vue?vue&type=script&lang=js"
export * from "./CourseCouponList.vue?vue&type=script&lang=js"
import style0 from "./CourseCouponList.vue?vue&type=style&index=0&id=dd3e6888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3e6888",
  null
  
)

export default component.exports